const PAGES = {
    home          : "navbar_home",
    about         : "navbar_about",
    documentation : "navbar_documentation",
    download      : "navbar_download",
    pdb2pqr       : "navbar_pdb2pqr",
    apbs          : "navbar_apbs",
    status        : "navbar_status",
    tools         : "navbar_tools",
}

export default PAGES;